import { useState } from 'react';

export default function RegionalJobs() {
  const [selectedRegion, setSelectedRegion] = useState('강남');

  const regions = [
    { name: '강남', icon: 'ri-building-line', count: '120+' },
    { name: '홍대', icon: 'ri-music-line', count: '95+' },
    { name: '건대', icon: 'ri-store-line', count: '87+' },
    { name: '수원', icon: 'ri-map-pin-line', count: '76+' },
    { name: '인천', icon: 'ri-ship-line', count: '68+' },
    { name: '부산', icon: 'ri-sun-line', count: '54+' }
  ];

  return (
    <section id="regions" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-1.5 bg-purple-50 rounded-full">
            <span className="text-sm text-purple-700 font-medium">지역별 정보</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            지역별 밤알바 정리
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            내가 일하고 싶은 지역 알바를 한눈에 확인하세요
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-12">
          {regions.map((region) => (
            <button
              key={region.name}
              onClick={() => setSelectedRegion(region.name)}
              className={`group p-6 rounded-2xl transition-all duration-300 cursor-pointer border-2 ${
                selectedRegion === region.name
                  ? 'bg-purple-600 border-purple-600 shadow-lg scale-105'
                  : 'bg-white border-gray-200 hover:border-purple-300 hover:shadow-md'
              }`}
            >
              <div className={`w-10 h-10 mx-auto mb-3 rounded-xl flex items-center justify-center transition-colors ${
                selectedRegion === region.name
                  ? 'bg-white/20'
                  : 'bg-gray-100 group-hover:bg-purple-50'
              }`}>
                <i className={`${region.icon} text-xl ${
                  selectedRegion === region.name
                    ? 'text-white'
                    : 'text-gray-700 group-hover:text-purple-600'
                }`}></i>
              </div>
              <h3 className={`text-base font-bold mb-1 ${
                selectedRegion === region.name
                  ? 'text-white'
                  : 'text-gray-900'
              }`}>
                {region.name}
              </h3>
              <p className={`text-xs font-medium ${
                selectedRegion === region.name
                  ? 'text-white/80'
                  : 'text-gray-500'
              }`}>
                {region.count} 공고
              </p>
            </button>
          ))}
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-10 border border-gray-100">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-2xl font-bold text-gray-900">
              {selectedRegion} 지역 알바
            </h3>
            <button className="text-sm text-purple-600 font-medium hover:text-purple-700 transition-colors cursor-pointer whitespace-nowrap">
              전체 보기 →
            </button>
          </div>
          
          <p className="text-sm text-gray-500 mb-8">
            아래는 미리보기 예시입니다. 실제 공고는 회원가입 후 확인하실 수 있어요.
          </p>

          <div className="grid md:grid-cols-2 gap-5">
            {[1, 2, 3, 4].map((item) => (
              <div 
                key={item}
                className="group bg-white rounded-2xl p-6 hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-purple-200 cursor-pointer"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2.5 py-1 bg-purple-50 text-purple-700 text-xs font-medium rounded-lg">
                        {selectedRegion}
                      </span>
                      <span className="px-2.5 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded-lg">
                        급구
                      </span>
                    </div>
                    <h4 className="text-base font-bold text-gray-900 mb-2 group-hover:text-purple-600 transition-colors">
                      {selectedRegion} 지역 밤알바 모집
                    </h4>
                    <p className="text-sm text-gray-600 mb-3">
                      시급 {100000 + item * 10000}원 · 주 3-4일 근무
                    </p>
                  </div>
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-lg text-gray-400 group-hover:text-purple-600 group-hover:translate-x-1 transition-all"></i>
                  </div>
                </div>
                <div className="flex items-center gap-4 text-xs text-gray-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    2시간 전
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    124
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}